import config from '../config';
import http from '@/utils/http';
import { logger } from '@/utils/screenEventsLogger';

export async function apiGetRss(rssUrl) {
  try {
    return await http.get(`${config.apiUrl}userapi/app/demo/rss?url=${rssUrl}`);
  } catch (error) {
    logger.addLog(`RSS API request failed: ${error?.message}. Url: ${rssUrl}`);

    return null;
  }
}
